// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"f9baaa4a","593":"54194b2e","732":"7590549b","859":"c345a5e4"}[chunkId] + ".chunk.js";
};